import palette from 'src/theme/palette';

export const cellBorderLeft = { borderLeft: `1px solid ${palette.light.grey[400]}` };
